import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import React, {useState, useRef, useEffect, useCallback, type ReactNode} from 'react';

interface Props {
    text: string | React.ReactElement | React.ReactNode
    svg?: string
    width?: number
    height?: number
    children?: ReactNode
    className?: string
}

const DEFAULT_SIZE = 20;

const ClickableTooltip = (props: Props): React.ReactElement => {
    const {text, svg, width, height, children, className} = props;
    const [active, setActive] = useState(false);

    const onClick = useCallback((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        setActive(prevActive => !prevActive);
    }, []);

    const modalRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (e: MouseEvent) => {
        e.stopPropagation();
        if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
            setActive(false);
        }
    };
    useEffect(() => {
        if (active) {
            document.addEventListener('click', handleClickOutside);
        } else {
            document.removeEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [active]);

    return <div className={`clickable-tooltip${active ? ' active' : ''}${className ? ` ${className}` : ''}`}>
        <button type="button" onClick={onClick}>
            {children ?? <SpriteIcon
                name={svg ?? '#svg-question'}
                size={{height: height ?? DEFAULT_SIZE, width: width ?? DEFAULT_SIZE}}
            />}
        </button>
        <div className="clickable-tooltip-description" ref={modalRef}>
            <div className="clickable-tooltip-description__inner">
                <div className="clickable-tooltip-description__content">{text}</div>
            </div>
        </div>
    </div>;
};

export default ClickableTooltip;
